import { Download, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

/**
 * Export a backend CSV endpoint as a downloadable file.
 *   <ExportCsvButton path="/admin/exports/premiums.csv" label="Export CSV" filename="premiums" />
 */
export default function ExportCsvButton({ path, label = "Export CSV", filename = "export", params, testid = "export-csv" }) {
  const [busy, setBusy] = useState(false);

  async function go() {
    setBusy(true);
    try {
      const { data } = await api.get(path, { params, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
      a.download = `fortiqa_${filename}_${stamp}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || "Export failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      onClick={go}
      disabled={busy}
      data-testid={testid}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider border border-[#114232]/15 rounded-md bg-white hover:bg-[#114232]/5 text-[#114232] transition-colors disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}
      {label}
    </button>
  );
}
